<template>
  <div class="app-review-modal">
    <!-- <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div> -->

    <div class="app-review-inner">
      
      <div class="review-stack">
        <h3>How are we doing?</h3>
        <p>How would you rate your Nourish experience?</p>
      </div>

      <div class="rating">
        <div class="star" v-for="idx in 5" :key="idx" @click="rate(idx)" :class="{'fill' : idx <= rating}">
          <svg width="83" height="79" viewBox="0 0 83 79" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M44.7422 1.96898C44.1237 0.766548 42.8715 0 41.5138 0C40.156 0 38.9039 0.766548 38.2853 1.96898L27.1819 23.6427L3.059 27.4605C1.71632 27.6709 0.599944 28.6178 0.17753 29.9104C-0.244884 31.203 0.102099 32.6159 1.05253 33.5778L18.3112 50.7876L14.5094 74.8211C14.2982 76.1588 14.8564 77.5115 15.9577 78.3081C17.059 79.1048 18.5073 79.225 19.7293 78.6088L41.5138 67.5765L63.2832 78.6088C64.4901 79.225 65.9535 79.1048 67.0547 78.3081C68.156 77.5115 68.7142 76.1738 68.503 74.8211L64.6862 50.7876L81.9448 33.5778C82.9104 32.6159 83.2423 31.203 82.8198 29.9104C82.3974 28.6178 81.2961 27.6709 79.9384 27.4605L55.8306 23.6427L44.7422 1.96898Z" fill="black"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        rating: null
      }
    },

    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    mounted() {
      this.EventBus.$emit('track:event', {
        event: 'feedback-ask-rating',
      });
    },

    methods: {
      close() {
        this.$emit('close');
      },

      rate(idx) {
        this.rating = idx; // base 0!

        if (this.rating < 5) {
          this.EventBus.$emit('track:event', {
            event: 'feedback-fewer-stars',
            props: { mode: this.rating},
            detail: { detail_char: this.rating },
          });
        } else {
          this.EventBus.$emit('track:event', {
            event: 'feedback-five-stars',
            props: { mode: this.rating},
            detail: { detail_char: this.rating },
          });
        }

        this.$userEngine.setPref("nourish.interactions.rating.score", this.rating);
        console.log(`Set rating: ${this.rating}`);
        // remove CTA, just fire in .6s
        setTimeout(this.submit, 600);
      },

      submit() {
        this.close();
        setTimeout(() => {
          this.EventBus.$emit('layer:new', {
            component: 'app-review-feedback',
            opts: {
              rating: this.rating
            }
          });
        }, 100)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .app-review-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    color: white;
    background-color: $neutral-100;
    background: radial-gradient(circle at bottom right, rgba($green-tone-6, 1), rgba($neutral-100, 1) 70%);
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    max-width: 900px;
    margin: 0 auto;
    padding-bottom: calc(env(safe-area-inset-bottom) + 2rem);

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
      cursor: pointer;
      margin: 1.5rem 1.5rem 0 0;
    }

    .app-review-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 4rem 1.5rem 5rem 1.5rem;
      max-width: 500px;
      margin: 0 auto;
      text-align: center;

      .app-review-icon {
        margin-bottom: 1rem;

        svg {
          fill: $green-tone-3;
        }
      }

      .review-stack {
        display: flex;
        flex-direction: column;
        gap: 0;
      }

      .rating {
        display: flex;
        gap: 1rem;
        margin: 1.4rem 0 0 0;

        .star {
          svg {
            width: 2.5rem;
            height: 2.5rem;

            path {
              fill: rgba($green-tone-5, 1);
              transition: all 0.2s ease-in-out;
            }
          }

          &.fill {
            svg path {
              fill: $green-tone-3;
            }
          }
        }
      }

      h2 {
        font-family: 'Circular';
        font-weight: bold;
        font-size: 4rem;
        line-height: 110%;
        color: $green-tone-3;
      }

      h3 {
        font-family: 'Circular';
        font-weight: bold;
        font-size: 1.8rem;
        line-height: 110%;
        color: $green-tone-3;
        text-wrap: balance;
      }

      p {
        font-size: 1.1rem;
        text-wrap: balance;
        margin-top: 1rem;
      }
    }
  }
</style>    